import { formatDateTime } from "./functions";

export const logRequestTrace = (level, event, trace, details = {}) => {
  const startedAt = trace.startedAt instanceof Date ? trace.startedAt : new Date(trace.startedAt);
  const isStarted = event.endsWith(".started");
  const isPending = event.endsWith(".pending");
  const commonDetails = {
    operationName: trace.operationName,
    event,
    correlationId: trace.correlationId,
    startedAt: formatDateTime(startedAt),
  };

  if (!isStarted) {
    commonDetails[isPending ? "observedAt" : "finishedAt"] = formatDateTime(new Date());
    commonDetails.durationMs = Date.now() - trace.startedAtMs;
  }

  console[level](JSON.stringify({ ...commonDetails, ...details }));
};
